var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"title",rawName:"v-title"}],attrs:{"id":"app","data-title":"域善科技"}},[_c('ysHeader'),_c('router-view'),_c('ysFoot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }